























































































































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import {
  COMPANY_FETCH_COMPANY_STRUCTURE,
  LOAD_PLAN,
  LOAD_SHIFTS,
  MESSAGING_LOAD_NEW_MESSAGES,
  LOAD_ABSENCES,
  DELETE_ABSENCES_CHECKED_LIST,
  DELETE_ABSENCE,
  CREATE_NEW_ABSENCE,
  APPROVED_ABSENCES_CHECKED_LIST,
  LOAD_ABSENCE_REASON_LIST,
  ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM,
  ABSENCE_DRAG_SAVE,
  FETCH_SHIFT_TOOLTIP,
  FETCH_ABSENCE_TOOLTIP, FETCH_CALENDAR_ART_TOOLTIP, FETCH_ABSENCE_SERIE_DATA, SCHEDULING_SET_PARAMETERS,
} from '@/store/action-types'
import { CompanyStructure, CheckedAbsenceList, TimeRange } from '@/types'
import {
  AbsenceEventDropPayload, AbsencePayload,
  CompanyFilterValue, NewAbsencePayload,
  PlanPayload,
  ShiftListPayload,
} from '@/types/payload'
import {
  PlanResponse,
  ShiftPlanResponse,
  PlanItem, GetAbsenceSeriesResponse, AbsenceSerie
} from '@/types/service-response'
import { DatePeriod } from '@/model/DatePeriod'
import { Employee } from '@/model/companyStructure/Employee'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { EmployeeResource } from '@/model/planning/EmployeeResource'
import { AbsencesEmployeeResource } from '@/model/absences/AbsencesEmployeeResource'
import { PlannedShift } from '@/model/planning/PlannedShift'
import CompanyFilter from '@/components/absences/CompanyFilter.vue'
import AbsenceList from '@/components/absences/AbsencesList.vue'
import SchedulerAbsencesToolbar from '@/components/absences/SchedulerAbsencesToolbar.vue'
import { Tooltip } from '@bryntum/scheduler'
import { BryntumScheduler } from '@bryntum/scheduler-vue';
import AbsenceEditor from '@/components/absences/absence/AbsencesEditor.vue'
import {
  DatePeriodEnum,
  SchedulerResourceEnum,
  SnackbarStateEnum,
  ViewEnum,
  ActionsEnum, SecurityArea, SecurityComponent
} from '@/types/enums'
import { EventTimePeriod } from '@/model/planning/EventTimePeriod'
import { TranslateResult } from 'vue-i18n'
import {
  COMPANY_GET_BASIC_COMPANY_STRUCTURE,
  COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST,
  GET_CURRENT_USER_DRAG_AND_DROP, GET_CURRENT_USER_ID,
  GET_CURRENT_USER_IS_ABSENCE_APPROVE,
  GET_CURRENT_USER_RESIZE,
  GET_IS_CAPELO, GET_SECURITY_LEVEL, SCHEDULING_GET_PARAMETERS
} from '@/store/getter-types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import {
  MESSAGING_SET_MESSAGES_DATA_MUTATION
} from '@/store/mutation-types'
import { AbsenceReason } from '@/model/absences/AbsenceReason'
import { Absence } from '@/model/absences/Absence'
import { AbsencesEditorPayload } from '@/model/absences/AbsencesEditorPayload'
import { SelectedEmployee } from '@/model/absences/SelectedEmployee'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { Holiday } from '@/model/companyStructure/Holiday'
import WarningDialog from '@/components/WarningDialog.vue'
import { NoteTooltip } from '@/model/planning/NoteTooltip'
import * as securityService from '@/services/security-service'
import { getColorContrast } from '@/services/get-color-contrast'
import i18n from '@/i18n'

let employeeEventListIndexedByAbsenceId: any = {}

interface ComponentData {
  drawer: boolean
  period: DatePeriodEnum
  companyStructure: CompanyStructure
  companyFilterValue: CompanyFilterValue
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  selectedReasonItem: AbsenceReason | undefined

  isFastPlanningDisabled: boolean
  isFastPlanningActive: boolean
  fastPlanningButtonInactive: boolean
  currentPeriod: DatePeriod
  currentAbsence: Absence | undefined

  // filter configuration
  showOnlyEmployeesWithAbsence: boolean

  // data
  employeeResourceList: Array<AbsencesEmployeeResource>
  employeeEventList: Array<EmployeeEvent>
  shiftList: Array<PlannedShift>
  absenceList: Array<Absence>
  timeRanges: Array<TimeRange>

  // scheduler
  schedulerPreset: Object
  schedulerColumns: Array<Object>
  schedulerResources: Array<EmployeeResource>
  schedulerEvents: Array<EmployeeEvent>
  schedulerStartDate: Date
  schedulerEndDate: Date

  // sheduler
  groupFeature: Object
  sortFeature: string
  stripeFeature: boolean
  scheduleTooltipFeature: boolean
  eventTooltipFeature: any
  timeRangesFeature: any
  resources: Array<any>
  events: Array<any>
  timeAxisHeaderMenuFeature: any
  eventContextMenuFeature: any

  showAbsencesEditor: boolean
  absencesEditorPayload: AbsencesEditorPayload | undefined
  selectedAbsence: any
  styledAbsences: Array<EmployeeEvent>
  resetSearchFilter: boolean
  showDeleteDialog: boolean
  action: ActionsEnum | undefined
  selectedEmployeeList: SelectedEmployee[]
  editAbsence: Absence | undefined
  editAbsenceSerie: AbsenceSerie | undefined
  isEditingAbsence: boolean
  selectedDetailId: number | null
  checkedList: Array<CheckedAbsenceList>
  unselect: boolean
  toolbarFilterScope: number
  toolbarFilterSearchString: string | null
  filteredEmployees: Array<Employee>
  loading: boolean
  yearPeriodScrollDate: Date
  isYearPeriodChangeDate: boolean
  selectedAbsenceTemplateName: string | undefined
  allowAbsenceDragAndDrop: boolean
  holidayList: Array<TimeRange>
  showWarningDialog: boolean
  warningMessage: string
  dragAndResizeContext: any
  filteredAbsenceList: Absence[] | undefined
  tooltipList: any
  isSelectAbsenceSerieActive: boolean

  presetList: any
}

export default Vue.extend({
      name: 'AbsencesPage',

      components: {
        CompanyFilter,
        AbsenceList,
        SchedulerAbsencesToolbar,
        BryntumScheduler,
        AbsenceEditor,
        DeleteDialog,
        ProgressCircular,
        WarningDialog
      },

      data (): ComponentData {
        const currentPeriod: DatePeriod = DatePeriod.createFromNow(DatePeriodEnum.Month)

        return {
          drawer: false,
          period: DatePeriodEnum.Month,
          showSnackbar: false,
          snackbarState: 0,
          messageSnackbar: '',
          selectedReasonItem: undefined,

          companyStructure: {
            profitCenterList: [],
            departmentList: [],
            planningGroupList: [],
            employeeList: []
          },

          companyFilterValue: {
            profitCenter: undefined,
            department: undefined,
            planningGroup: undefined,
            employee: undefined
          },

          isFastPlanningDisabled: true,
          isFastPlanningActive: false,
          fastPlanningButtonInactive: false,
          currentPeriod: currentPeriod,
          currentAbsence: undefined,

          // filter configuration
          showOnlyEmployeesWithAbsence: false,

          // data
          employeeResourceList: [],
          employeeEventList: [],
          shiftList: [],
          absenceList: [],

          // <editor-fold desc="Scheduler data & config">
          schedulerPreset: DatePeriodEnum.Month,
          schedulerColumns: [
            {
              text: this.$i18n.t('planningPage.planningGroupMenu'),
              width: 150,
              field: 'planningGroupName',
              hidden: true
            },
            {
              text: this.$i18n.t('planningPage.positionMenu'),
              width: 50,
              field: 'position',
              hidden: true
            },
            {
              text: this.$i18n.t('planningPage.employee'),
              width: 150,
              field: 'fullName'
            }
          ],
          schedulerResources: [],
          schedulerEvents: [],
          schedulerStartDate: currentPeriod.startDate,
          schedulerEndDate: currentPeriod.endDate,
          timeRanges: [],

          // scheduler
          groupFeature: {
            field       : 'planningGroupName',
            groupSortFn : (a: any, b: any) => {
              if(a.planningGroupName === b.planningGroupName) {
                return a.position > b.position ? 1 : -1
              } else {
                if (a.planningGroupName === i18n.t('planningPage.floater').toString()) {
                  return 1
                } else if (b.planningGroupName === i18n.t('planningPage.floater').toString()) {
                  return -1
                } else {
                  if (a.planningGroupName < b.planningGroupName) {
                    return -1
                  }
                  if (a.planningGroupName > b.planningGroupName) {
                    return 1
                  }
                  return 0
                }
              }
            }
          },
          sortFeature: 'position',
          stripeFeature: true,
          scheduleTooltipFeature: false,
          eventTooltipFeature: undefined,
          timeRangesFeature: {
            showCurrentTimeLine : false,
            showHeaderElements  : false,
            enableResizing      : false
          },
          resources: [],
          events: [],
          timeAxisHeaderMenuFeature: {
            processItems: (event : any) => {
              const x = event.point[0]
              const timeAxisView = event.column.timeAxisViewModel
              const headerRect = event.headerElement.getBoundingClientRect()
              const date = timeAxisView.getDateFromPosition(x - headerRect.left)
              const formattedDate = moment(date).format('YYYY-MM-DD')
              //@ts-ignore
              const foundHoliday: TimeRange | undefined = this.holidayList.find((item: TimeRange) => item.startDate === formattedDate)

              const { items } = event
              Object.keys(items).forEach(key => delete items[key])
              items.customHtmlBlock = foundHoliday && foundHoliday.data && foundHoliday.data.length > 0 && foundHoliday.data[0].bezeichnung ? {
                type: 'widget',
                html: ` <div style="padding: 4px; min-width: 150px !important; background-color: #fff; font-family: Roboto, sans-serif;">
                    ${foundHoliday.data.map((holidayItem: any) => {
                  return `
                        <div style="padding-bottom: 4px; "><b>${holidayItem.bezeichnung}</b></div>
                        ${holidayItem.land.map((landItem: any) => {
                    const bundeslandString: any = landItem.bundesland.join(', ')
                    return `<div>${landItem.landISO}: ${bundeslandString}</div>`
                  }).join('')}
                      `;
                }).join('')}
                  </div>
                `,
                weight: 100
              } : ''
            },
          },
          eventContextMenuFeature: undefined,
          // </editor-fold>

          showAbsencesEditor: false,
          absencesEditorPayload: undefined,
          selectedAbsence: undefined,
          styledAbsences: [],
          resetSearchFilter: false,
          showDeleteDialog: false,
          action: undefined,
          selectedEmployeeList: [],
          editAbsence: undefined,
          editAbsenceSerie: undefined,
          isEditingAbsence: true,
          selectedDetailId: null,
          checkedList: [],
          unselect: false,
          toolbarFilterScope: 0,
          toolbarFilterSearchString: null,
          filteredEmployees: [],
          loading: false,
          yearPeriodScrollDate: moment().toDate(),
          isYearPeriodChangeDate: false,
          selectedAbsenceTemplateName: undefined,
          allowAbsenceDragAndDrop: false,
          holidayList: [],
          showWarningDialog: false,
          warningMessage: '',
          dragAndResizeContext : undefined,
          filteredAbsenceList: undefined,
          tooltipList: [],
          isSelectAbsenceSerieActive: false,

          presetList: [
            {
              id: 'year',
              tickWidth: 50,
              //displayDateFormat: 'HH:mm',
              shiftIncrement: 1,
              shiftUnit: 'month',
              //defaultSpan: 24,

              timeResolution: {
                unit: 'minute',
                increment: 15
              },

              headers: [
                {
                  unit: 'week',
                  dateFormat: 'W',
                  align: 'center',
                  renderer: function (start: string | Date) {
                    return i18n.t('calendarWeek').toString() + ' '  + moment(start).locale('de').format('W');
                  }
                },
                {
                  unit: 'month',
                  dateFormat: 'MMMM',
                  align: 'center',
                  renderer: function (start: string | Date) {
                    return moment(start).locale('de').format('MMMM') +" "+ moment(start).locale('de').format('YYYY');
                  }
                },
                {
                  unit: 'day',
                  dateFormat: 'dd',
                  align: 'center',
                  renderer: function(start: string | Date){
                    return moment(start).locale('de').format('DD') +' '+ moment(start).locale('de').format('dd');
                  }
                }
              ],
              columnLinesFor: 2

            },
            {
              id: 'month',
              tickWidth: 35,
              //displayDateFormat: 'HH:mm',
              shiftIncrement: 1,
              shiftUnit: 'month',
              //defaultSpan: 24,

              timeResolution: {
                unit: 'minute',
                increment: 15
              },

              headers: [
                {
                  unit: 'week',
                  dateFormat: 'W',
                  align: 'center',
                  renderer: function (start: string | Date) {
                    return i18n.t('calendarWeek').toString() + ' ' + moment(start).locale('de').format('W');
                  }
                },
                {
                  unit: 'day',
                  dateFormat: 'DD',
                  align: 'center',
                },
                {
                  unit: 'day',
                  dateFormat: 'dd',
                  align: 'center',
                  renderer: function(start: string | Date){
                    return moment(start).locale('de').format('dd');
                  }
                }
              ],
              columnLinesFor: 2

            },
            {
              id: 'week',
              tickWidth: 60,
              //displayDateFormat: 'HH:mm',
              shiftIncrement: 1,
              shiftUnit: 'week',
              //defaultSpan: 24,

              timeResolution: {
                unit: 'minute',
                increment: 15
              },

              headers: [
                {
                  unit: 'week',
                  dateFormat: 'W',
                  align: 'center',
                  renderer: function (start: string | Date) {
                    return i18n.t('calendarWeek').toString() + ' '  + moment(start).locale('de').format('W');
                  }
                },
                {
                  unit: 'day',
                  dateFormat: 'DD',
                  align: 'center'
                },
                {
                  unit: 'day',
                  dateFormat: 'dd',
                  align: 'center',
                  renderer: function(start: string | Date){
                    return moment(start).locale('de').format('dd');
                  }
                }
              ],
              columnLinesFor: 1
            },
            {
              id: 'day',
              tickWidth: 44,

              displayDateFormat: 'HH:mm',

              shiftIncrement: 1,
              shiftUnit: 'day',
              defaultSpan: 12,

              timeResolution: {
                unit: 'minute',
                increment: 15
              },

              headers: [
                {
                  unit: 'week',
                  dateFormat: 'W',
                  align: 'center',
                  renderer: function (start: string | Date) {
                    return i18n.t('calendarWeek').toString() + ' '  + moment(start).locale('de').format('W');
                  }
                },
                {
                  unit: 'day',
                  dateFormat: 'dddd DD MMM YYYY',
                  align: 'center',
                  renderer: function(start: string | Date, end: string | Date, headerConfig: any, index: any){
                    return moment(start).locale('de').format('dddd DD MMM YYYY');
                  }
                },
                {
                  unit: 'hour',
                  dateFormat : this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.xsOnly ? 'HH' : 'HH:mm',
                  align: 'center',
                }
              ],

              columnLinesFor: 1
            }
          ]
        }

      },

      computed: {
        shouldUpdateData (): boolean {
          return false
        },
        snackbarColor (): boolean {
          return this.snackbarState === SnackbarStateEnum.Success
        },
        schedulerAutoHeight (): boolean {
          if (this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.xsOnly) {
            return false
          } else {
            return false
          }
        },
        currentUserDragAndDrop (): boolean {
          return this.$store.getters[GET_CURRENT_USER_DRAG_AND_DROP]
        },
        currentUserResize (): boolean {
          return this.$store.getters[GET_CURRENT_USER_RESIZE]
        },
        isCapelo (): boolean {
          return this.$store.getters[GET_IS_CAPELO]
        },
        isAbsenceApproved (): boolean {
          return this.$store.getters[GET_CURRENT_USER_IS_ABSENCE_APPROVE]
        },

        currentUserId (): number {
          return this.$store.getters[GET_CURRENT_USER_ID]
        },

        currentUserSecurity (): number {
          return this.$store.getters[GET_SECURITY_LEVEL]
        },
      },

      watch: {
        currentPeriod (newVal: DatePeriod): void {
          let data: any = undefined
          try {
            //@ts-ignore
            data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
          } catch (e) {
            data = {}
          }

          data.currentPeriod = newVal
          this.$router.push({name: 'absences', query: { data: JSON.stringify(data) }})
          let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
          schedulingData.currentPeriod = data.currentPeriod
          this.$store.dispatch(SCHEDULING_SET_PARAMETERS, schedulingData)

          // @ts-ignore
          const engine = this.$refs.scheduler.instance
          if (this.period !== newVal.period) {
            if(newVal.period === DatePeriodEnum.WorkingWeek) {
              engine.viewPreset = DatePeriodEnum.Week
              this.period = newVal.period
            } else {
              engine.viewPreset = newVal.period
              this.period = newVal.period
            }
          }

          engine.setStartDate(newVal.startDate)
          engine.setEndDate(newVal.endDate)

          if(newVal.period === DatePeriodEnum.Year) {
            setTimeout(() => {
              engine.scrollToDate(moment(this.yearPeriodScrollDate),
                  {
                    block: 'start'
                  }
              )
            }, 0)
          }
          this.setTimeRanges(newVal.startDate, newVal.endDate)
          this.updateDataSet().then(() => this.updateSchedulerData())
        }
      },

      methods: {
        activateSelectAbsenceSerie (isSelectAbsenceSerieActive: boolean): void {
          this.isSelectAbsenceSerieActive = isSelectAbsenceSerieActive
        },

        yearPeriodChangeDate (date: string): void {
          this.isYearPeriodChangeDate = true
          this.yearPeriodScrollDate = moment(date, "YYYY-MM-DD").toDate()
          // @ts-ignore
          const engine = this.$refs.scheduler.instance
          engine.scrollToDate(moment(date, "YYYY-MM-DD").toDate(),
              {
                block: 'start'
              }
          )
          setTimeout(() => { this.isYearPeriodChangeDate = false}, 500)
        },

        horizontalScroll (data: any) {
          if(this.period === DatePeriodEnum.Year && !this.isYearPeriodChangeDate) {
            const number = Math.floor((data.scrollLeft)/50 )
            const selectedYear = moment(this.yearPeriodScrollDate).format('YYYY')
            const start = moment(selectedYear).startOf('year')
            this.yearPeriodScrollDate = moment(start).add(number, 'day').toDate()
          }
        },

        filterScopeChange (item: number): void {
          this.toolbarFilterScope = item
        },

        filterSearchString (item: string | null): void {
          this.toolbarFilterSearchString = item
        },

        disableEdit (item: Array<CheckedAbsenceList>): void {
          this.checkedList = item
          this.unselect = false
        },

        onFilterValueChanged (payload: CompanyFilterValue): void {
          this.companyFilterValue = payload
          this.resetSearchFilter = true

          this.updateDataSet().then(() => this.updateSchedulerData())
          this.fastPlanningButtonInactive = !this.fastPlanningButtonInactive
        },

        onAbsenceSelected (item: Absence): void {
          if (item) {
            this.currentAbsence = item
            // @ts-ignore
            const engine = this.$refs.scheduler.instance

            let newStyledAbsences: Array<EmployeeEvent> = []

            if(this.isSelectAbsenceSerieActive && item.serieId) {
              this.selectedDetailId = item.id
              const filteredAbsences: Absence[] = this.absenceList.filter((i: Absence) => i.serieId === item.serieId)
              this.schedulerEvents.forEach((i: EmployeeEvent) => {
                const foundAbsence: Absence | undefined = filteredAbsences.find((a: Absence) => a.id === i.absenceId)
                if (foundAbsence) {
                  newStyledAbsences.push(i)
                }
              })

              let numberOfAbsences: number = 0
              if (newStyledAbsences !== this.styledAbsences) {
                this.styledAbsences.forEach((item: EmployeeEvent) => {
                  const foundItem: any = engine.eventStore.getById(item.id)
                  /*if (foundItem) {
                    foundItem.set('style', 'plain')
                    foundItem.set('style', `${item.style}!important;`)
                  }*/
                  engine.selectEvent(foundItem)
                })

                this.styledAbsences = newStyledAbsences
              }

              this.styledAbsences.forEach((item: EmployeeEvent) => {
                if (numberOfAbsences === 0) {
                  const foundItem: any = engine.eventStore.getById(item.id)
                  //foundItem.set('style', 'color: white!important;')
                  engine.selectEvent(foundItem)
                  numberOfAbsences++
                } else if (numberOfAbsences > 0 && numberOfAbsences < this.styledAbsences.length) {
                  const foundItem: any = engine.eventStore.getById(item.id)
                  //foundItem.set('style', 'color: white!important;')
                  engine.selectEvent(foundItem, true)
                } else if (numberOfAbsences === this.styledAbsences.length) {
                  const foundItem: any = engine.eventStore.getById(item.id)
                  //foundItem.set('style', 'color: white!important;')
                  engine.selectEvent(foundItem)
                  numberOfAbsences++
                }
              })
            } else {
              /*this.styledAbsences.forEach((item: EmployeeEvent) => {
                const foundItem: any = engine.eventStore.getById(item.id)
                if (foundItem) {
                  foundItem.set('style', 'plain')
                  foundItem.set('style', `${item.style}!important;`)
                }
              })*/

              if(this.selectedAbsence) {
                const foundEvent: EmployeeEvent | undefined = this.schedulerEvents.find((i: EmployeeEvent) => i.absenceId === this.selectedAbsence.absenceId)
                if (foundEvent) {
                  this.selectedDetailId = foundEvent.absenceId
                  newStyledAbsences.push(foundEvent)
                  const foundItem: any = engine.eventStore.getById(foundEvent.id)
                  //foundItem.set('style', 'color: white!important;')
                  engine.selectEvent(foundItem)
                }
              } else {
                const foundEvent: EmployeeEvent | undefined = this.schedulerEvents.find((i: EmployeeEvent) => i.absenceId === item.id)
                if (foundEvent) {
                  this.selectedDetailId = foundEvent.absenceId
                  newStyledAbsences.push(foundEvent)
                  const foundItem: any = engine.eventStore.getById(foundEvent.id)
                  //foundItem.set('style', 'color: white!important;')
                  engine.selectEvent(foundItem)
                }
              }
              this.styledAbsences = newStyledAbsences
            }
          } else {
            // @ts-ignore
            const engine = this.$refs.scheduler.instance
            engine.clearEventSelection()
            /*this.styledAbsences.forEach((item: EmployeeEvent) => {
              const foundItem: any = engine.eventStore.getById(item.id)
              if (foundItem) {
                foundItem.set('style', 'plain')
                foundItem.set('style', `${item.style}!important;`)
              }
            })*/
            this.selectedAbsence = undefined
          }
        },

        onSchedulerSelect (e: any): void {
          if (e && e.selection[0] && e.selection[0].data) {

            // @ts-ignore
            const engine = this.$refs.scheduler.instance

            const floaterEvents: Array<number> = []
            this.employeeEventList.forEach((item: EmployeeEvent) => {
              if (this.companyFilterValue.department && item.department != this.companyFilterValue.department.id) {
                floaterEvents.push(item.id)
              }
            })

            if (e.selection[0].data.type === 'absence') {
              if (floaterEvents.includes(e.selection[0].data.id)) {
                this.selectedAbsence = undefined
              } else {
                this.selectedAbsence = e.selection[0].data
              }
            } else if (e.selection[0].data.type === 'floater' || e.selection[0].data.type === 'calendar' || e.selection[0].data.type === 'shift' || e.selection[0].data.type === 'originalShift') {
              this.unselect = true
              this.selectedAbsence = undefined

              engine.clearEventSelection()
              /*this.styledAbsences.forEach((item: EmployeeEvent) => {
                const foundItem: any = engine.eventStore.getById(item.id)
                if (foundItem) {
                  foundItem.set('style', 'plain')
                  foundItem.set('style', `${item.style}!important;`)
                }
              })*/
            }
            this.checkedList = []
          }
        },

        hasSatisfySchedule (list: Array<Absence>, item: AbsencesEmployeeResource): boolean {
          if(item.eventList.find((event: EmployeeEvent) => {
            return list.some((absence: Absence) => {
              return absence.id === event.absenceId
            })
          })) {
            return true
          } else {
            return false
          }
        },

        filteredAbsencesList (list: Array<Absence>): void {
          // @ts-ignore
          const engine = this.$refs.scheduler.instance
          engine.resourceStore.clearFilters()
          if (this.toolbarFilterSearchString || this.toolbarFilterScope !== 0) {
            this.filteredAbsenceList = list
            //const filteredEmployeeResourceList: Array<AbsencesEmployeeResource> = this.employeeResourceList.filter((item: AbsencesEmployeeResource) => this.hasSatisfySchedule(list, item))

            engine.resourceStore.filterBy((item: any) => {
              return this.hasSatisfySchedule(list, item) && item.eventList.filter((i: EmployeeEvent) => i.type === 'absence').length > 0
            })

            //this.schedulerResources = _.filter(filteredEmployeeResourceList,
                //function (item) {return item.eventList.filter((i: EmployeeEvent) => i.type === 'absence').length > 0})

          } else {
            this.schedulerResources = this.employeeResourceList
          }

          this.checkedList = []
          engine.clearEventSelection()
          /*this.styledAbsences.forEach((item: EmployeeEvent) => {
            const foundItem: any = engine.eventStore.getById(item.id)
            if (foundItem) {
              foundItem.set('style', 'plain')
            }
          })*/
          this.selectedAbsence = undefined
          this.styledAbsences = []
          if (list) {
            if (this.employeeEventList) {
              let absencesList: Array<EmployeeEvent> = []
              /*list.forEach((item: any) => {
                absencesList = absencesList.concat(employeeEventListIndexedByAbsenceId[item.id])
              })*/
              this.employeeEventList.forEach((i: EmployeeEvent) => {
                //if (i.type !== 'absence') {
                absencesList.push(i)
                //}
              })
              this.schedulerEvents = absencesList
              if (this.schedulerEvents.length !== this.employeeEventList.length) {
                this.resetSearchFilter = false
              }
            }
          }
        },

        updateEventList () {
          this.schedulerEvents = this.employeeEventList
        },

        onPeriodSelected (period: DatePeriod): void {
          this.loading = true
          this.currentPeriod = period
        },

        onShowOnlyEmployeesWithAbsence (value: boolean): void {
          this.showOnlyEmployeesWithAbsence = value

          this.updateSchedulerData()
        },

        newAbsenceCreated (): void {
          this.closeAbsenceEditor()
          this.updateDataSet().then(() => this.updateSchedulerData())
          this.messageSnackbar = this.$t('absencesPage.absenceSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        },

        newAbsenceCreatedFalse (): void {
          this.closeAbsenceEditor()
          this.messageSnackbar = this.$t('absencesPage.absenceCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        },

        absenceEdited (): void {
          this.closeAbsenceEditor()
          this.updateDataSet().then(() => this.updateSchedulerData())
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        },

        absenceEditedFalse (): void {
          this.closeAbsenceEditor()
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        },

        onCloseEditor (): void {
          this.closeAbsenceEditor()
        },

        onSchedulerEventDrop (event: any): void {
          const data: any = event.eventRecords[0]
          const payload: AbsenceEventDropPayload = {
            absenceId: data.data.absenceId,
            employeeId: data.resourceId,
            startDate: moment(data.data.startDate).format('YYYY-MM-DD HH:mm'),
            endDate: moment(data.data.endDate).format('YYYY-MM-DD HH:mm')
          }
          this.eventDragSave(payload)
        },

        onSchedulerEventResizeEnd (event: any): void {
          if(event.changed) {
            const data: any = event.eventRecord.data
            let endDate: string
            if (moment(data.endDate).format('HH:mm') === '00:00') {
              endDate = moment(data.endDate).subtract(1, 'minute').format('YYYY-MM-DD HH:mm')
            } else {
              endDate = moment(data.endDate).format('YYYY-MM-DD HH:mm')
            }

            const payload: AbsenceEventDropPayload = {
              absenceId: data.absenceId,
              employeeId: data.employeeId,
              startDate: moment(data.startDate).format('YYYY-MM-DD HH:mm'),
              endDate: endDate
            }
            this.eventDragSave(payload)
          }
        },

        async eventDragSave (payload: AbsenceEventDropPayload): Promise<void> {
          this.loading = true
          try {
            const data = await this.$store.dispatch(ABSENCE_DRAG_SAVE, payload)
            if (data) {
              this.updateDataSet().then(() => this.updateSchedulerData())
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.updateDataSet().then(() => this.updateSchedulerData())
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.updateDataSet().then(() => this.updateSchedulerData())
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          }

          this.showSnackbar = true
        },

        beforeEventDropFinalize (context: any): void {
          context.context.async = true;
          if(this.currentUserDragAndDrop) {
            this.warningMessage = this.$t('absencesPage.dragAndDropWarningMessage').toString()
            this.showWarningDialog = true
            this.dragAndResizeContext = context.context
          } else {
            context.context.finalize(true)
          }
        },

        beforeEventResizeFinalize (context: any): void {
          context.context.async = true;
          if(this.currentUserResize) {
            this.warningMessage = this.$t('absencesPage.resizeWarningMessage').toString()
            this.showWarningDialog = true
            this.dragAndResizeContext = context.context
          } else {
            context.context.finalize(true)
          }
        },

        onWarningDialogClose (): void {
          this.dragAndResizeContext.finalize(false)
          this.dragAndResizeContext = undefined
          this.showWarningDialog = false
        },

        onWarningDialogSave (): void {
          this.dragAndResizeContext.finalize(true)
          this.dragAndResizeContext = undefined
          this.showWarningDialog = false
        },

        onAddNewEmptyAbsence (): void {
          this.action = ActionsEnum.CREATE
          this.editAbsence = undefined
          this.editAbsenceSerie = undefined
          this.absencesEditorPayload = AbsencesEditorPayload.create(
              [],
              EventTimePeriod.createDefaultRange(),
              this.companyStructure,
              this.companyFilterValue
          )
          this.showAbsencesEditor = true
        },

        async onEditAbsenceClick (): Promise<void> {
          this.editAbsenceSerie = undefined
          this.editAbsence = this.absenceList.find((i: Absence) => i.id === this.selectedDetailId)
          if (this.editAbsence && (!this.isSelectAbsenceSerieActive || !this.editAbsence.serieId)) {
            this.isEditingAbsence = true
            this.openEditStepper()
          } else {
            this.isEditingAbsence = false
            this.editAbsence = undefined
            this.fetchAbsenceSerieData(this.currentAbsence!.serieId)
          }
        },

        openEditStepper (): void {
          this.action = ActionsEnum.EDIT
          this.fetchAbsencesReasonList()

          if (this.editAbsence) {
            this.absencesEditorPayload = AbsencesEditorPayload.edit(
                [],
                EventTimePeriod.editRange(new Date(this.editAbsence.start), new Date(this.editAbsence.end)),
                this.companyStructure,
                this.companyFilterValue
            )
          } else if(this.editAbsenceSerie) {
            this.absencesEditorPayload = AbsencesEditorPayload.edit(
                [],
                EventTimePeriod.editRange(new Date(this.editAbsenceSerie.StartDatum ? this.editAbsenceSerie.StartDatum : moment(this.editAbsenceSerie.Absences[0].DatumVon, 'DD.MM.YYYY HH:mm:ss').toDate()), new Date(this.editAbsenceSerie.EndDatum ? this.editAbsenceSerie.EndDatum : moment(this.editAbsenceSerie.Absences[0].DatumBis, 'DD.MM.YYYY HH:mm:ss').toDate())),
                this.companyStructure,
                this.companyFilterValue
            )
          }

          this.showAbsencesEditor = true
        },

        async fetchAbsenceSerieData (absenceSerieId: number): Promise<void> {
          try {
            const response: GetAbsenceSeriesResponse = await this.$store.dispatch(FETCH_ABSENCE_SERIE_DATA, absenceSerieId)
            if(!response.IsError && response.Series)
              this.editAbsenceSerie = response.Series
            this.openEditStepper()
          } catch {

          }
        },

        async fetchAbsencesReasonList (): Promise<void> {
          const absenceReasonList: Array<AbsenceReason> = await this.$store.dispatch(LOAD_ABSENCE_REASON_LIST)

          if (this.editAbsence) {
            const reasonItem: AbsenceReason | undefined = absenceReasonList.find((item: AbsenceReason) => item.id === this.editAbsence!.reason)
            this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM, reasonItem)
          } else if(this.editAbsenceSerie) {
            const reasonItem: AbsenceReason | undefined = absenceReasonList.find((item: AbsenceReason) => item.id === this.editAbsenceSerie!.Grund)
            this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM, reasonItem)
          }
        },

        onDeleteAbsenceClick (): void {
          this.showDeleteDialog = true
        },

        onDeleteDialogClose (): void {
          this.showDeleteDialog = false
        },

        onDeleteDialogSave (): void {
          if (this.checkedList.length > 0) {
            this.deleteCheckedList()
          } else if (this.selectedAbsence) {
            this.deleteAbsence()
          }
        },

        async deleteAbsence (): Promise<void> {
          let payload: number[] = []

          if(this.isSelectAbsenceSerieActive) {
            const foundAbsence: Absence | undefined = this.absenceList.find((item: Absence) => item.id === this.selectedAbsence.absenceId)
            if (foundAbsence && foundAbsence.serieId) {
              const filteredAbsences: Absence[] = this.absenceList.filter((i: Absence) => i.serieId === foundAbsence.serieId)
              filteredAbsences.forEach((a: Absence) => {
                payload.push(a.id)
              })
            } else if(foundAbsence) {
              payload.push(foundAbsence.id)
            }
          } else {
            const foundAbsence: Absence | undefined = this.absenceList.find((item: Absence) => item.id === this.selectedAbsence.absenceId)
            if (foundAbsence) {
              payload.push(foundAbsence.id)
            }
          }

          try {
            this.loading = true
            const response: boolean = await this.$store.dispatch(DELETE_ABSENCE, payload)
            this.loading = false
            this.showDeleteDialog = false
            if(response) {
              this.messageSnackbar = this.$t('absencesPage.absenceHasBeenDeleted')
              this.snackbarState = SnackbarStateEnum.Success
              this.showSnackbar = true
            } else {
              this.messageSnackbar = this.$t('absencesPage.absenceCouldNotBeDeleted')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
            }
            //this.updateDataSet().then(() => this.updateSchedulerData())
            this.deleteSchedulerEventList(payload)
          } catch (e) {
            this.loading = false
            this.showDeleteDialog = false
            this.messageSnackbar = this.$t('absencesPage.absenceCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        },

        async deleteCheckedList (): Promise<void> {
          if (this.checkedList) {
            let payload: number[] = []

            if(this.isSelectAbsenceSerieActive) {
              this.checkedList.forEach((item: CheckedAbsenceList) => {
                if(item.serieId) {
                  const filteredAbsences: Absence[] = this.absenceList.filter((i: Absence) => i.serieId === item.serieId)
                  filteredAbsences.forEach((a: Absence) => {
                    if(!payload.includes(a.id)) {
                      payload.push(a.id)
                    }
                  })
                } else {
                  payload.push(item.id)
                }
              })
            } else {
              this.checkedList.forEach((item: CheckedAbsenceList) => {
                payload.push(item.id)
              })
            }

            try {
              this.loading = true
              const response: boolean = await this.$store.dispatch(DELETE_ABSENCES_CHECKED_LIST, payload)
              this.loading = false
              this.showDeleteDialog = false
              if(response) {
                this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
                this.snackbarState = SnackbarStateEnum.Success
                this.showSnackbar = true
              } else {
                this.messageSnackbar = this.$t('absencesPage.absenceCouldNotBeDeleted')
                this.snackbarState = SnackbarStateEnum.Error
                this.showSnackbar = true
              }
              this.deleteSchedulerEventList(payload)
              //this.updateDataSet().then(() => this.updateSchedulerData())
            } catch (e) {
              this.loading = false
              this.showDeleteDialog = false
              this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
            }
          }
        },

        deleteSchedulerEvent (event: EmployeeEvent): void {
          if(event) {
            this.schedulerEvents.splice(this.schedulerEvents.indexOf(event), 1)

            const foundEmployeeEventItem: EmployeeEvent | undefined = this.employeeEventList.find((item: EmployeeEvent) => item.id === event.id)
            if(foundEmployeeEventItem) {
              this.employeeEventList.splice(this.employeeEventList.indexOf(foundEmployeeEventItem), 1)
            }

            const foundResource: EmployeeResource | undefined = this.schedulerResources.find((item: EmployeeResource) => item.id === event.employeeId)
            if(foundResource) {
              const foundResourceEvent: EmployeeEvent | undefined = foundResource.eventList.find((item: EmployeeEvent) => item.id === event.id)
              if(foundResourceEvent) {
                foundResource.eventList.splice(foundResource.eventList.indexOf(foundResourceEvent), 1)
              }
            }
            /*if(event.serie) {
              const filteredEvents: EmployeeEvent[] = this.schedulerEvents.filter((item: EmployeeEvent) => item.serie === event.serie)
              if (event.type === 'absence' && filteredEvents.length === 0) {
                const foundAbsence: Absence | undefined = this.absenceList.find((item: Absence) => item.serieId === event.serie)
                if (foundAbsence) {
                  this.absenceList.splice(this.absenceList.indexOf(foundAbsence), 1)
                }
              }
            } else {*/
              const foundAbsence: Absence | undefined = this.absenceList.find((item: Absence) => item.id === event.absenceId)
              if (foundAbsence) {
                this.absenceList.splice(this.absenceList.indexOf(foundAbsence), 1)
                const filteredAbsenceList: Absence[] = this.absenceList.filter((item: Absence) => item.serieId === event.serie).sort((a: Absence, b: Absence) => moment(a.start).milliseconds() - moment(b.start).milliseconds())
                if(filteredAbsenceList[0]) {
                  filteredAbsenceList[0].show = true
                }
              }
            //}
          }
        },

        deleteSchedulerEventList (absenceIdList: number[]): void {
          absenceIdList.forEach((absenceId: number) => {
            const foundItem: EmployeeEvent | undefined = this.schedulerEvents.find((item: EmployeeEvent) => item.absenceId === absenceId)
            if(foundItem) {
              this.deleteSchedulerEvent(foundItem)
            }
          })

          this.selectedAbsence = undefined
          this.styledAbsences = []
        },

        onActivateFastPlanning (isActive: boolean): void {
          this.isFastPlanningActive = isActive
        },

        absenceReasonSelect (reasonItem: AbsenceReason): void {
          if (reasonItem) {
            this.selectedReasonItem = reasonItem
            this.isFastPlanningDisabled = false
            this.selectedAbsenceTemplateName = reasonItem.description
          } else {
            this.selectedReasonItem = undefined
            this.isFastPlanningDisabled = true
            this.selectedAbsenceTemplateName = undefined
          }
        },

        async onScheduleClick (item: { source: any, date: Date, row: any, index: number, resourceRecord: any, event: MouseEvent }): Promise<any> {
          this.unselect = true
          this.selectedAbsence = undefined
          // @ts-ignore
          const engine = this.$refs.scheduler.instance
          engine.clearEventSelection()

          /*this.styledAbsences.forEach((item: EmployeeEvent) => {
            const foundItem: any = engine.eventStore.getById(item.id)
            if (foundItem) {
              foundItem.set('style', 'plain')
            }
          })*/
          this.styledAbsences = []

          if (this.isFastPlanningActive && this.selectedReasonItem && this.isEmployeeResource(item.resourceRecord.data)) {
            const employeeId: number = item.resourceRecord.data.id
            const dateStart = moment(item.date).set({ hour: 0, minute: 0, second: 0 })
            const dateEnd = moment(item.date).set({ hour: 23, minute: 59, second: 0 })

            const newAbsencePayload: NewAbsencePayload = {
              action: 'Insert',
              absenceApproved: this.isAbsenceApproved,
              absenceDisapproved: false,
              statusComment: '',
              whoApproved: this.isAbsenceApproved ? this.currentUserId : null,
              MRAID: '',
              employee: employeeId,
              dateStart: dateStart.toDate(),
              dateEnd: dateEnd.toDate(),
              comment: '',
              reason: this.selectedReasonItem.id,
              who: this.currentUserId,
              showAll: 0,
              medicalCertificate: false,
              medicalCertificateValid: null,
              employeeSecurity: this.currentUserSecurity,
              component: 'div_Login',
              id: 0
            }

            const payload: AbsencePayload = {
              abteilung: this.companyFilterValue.department!.id,
              data: [newAbsencePayload]
            }
            try {
              this.loading = true
              const newAbsence: boolean = await this.$store.dispatch(CREATE_NEW_ABSENCE, payload)

              if (newAbsence) {
                this.updateDataSet().then(() => this.updateSchedulerData())
                this.messageSnackbar = this.$t('absencesPage.absenceSaved')
                this.snackbarState = SnackbarStateEnum.Success
              } else {
                this.messageSnackbar = this.$t('absencesPage.absenceCouldNotBeSaved')
                this.snackbarState = SnackbarStateEnum.Error
              }
            } catch {
              this.messageSnackbar = this.$t('absencesPage.absenceCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            } finally {
              this.showSnackbar = true
              this.loading = false
            }
          }
        },

        isEmployeeResource (selectedItem: any): selectedItem is EmployeeResource {
          return selectedItem.type === SchedulerResourceEnum.Employee
        },

        async fetchEventList (): Promise<Array<EmployeeEvent>> {

          let view: ViewEnum = ViewEnum.TimelineMonth
          if (this.period === DatePeriodEnum.Week) {
            view = ViewEnum.TimelineWeek
          } else if (this.period === DatePeriodEnum.Day) {
            view = ViewEnum.Day
          } else if (this.period === DatePeriodEnum.Year) {
            view = ViewEnum.TimelineYear
          } else if (this.period === DatePeriodEnum.WorkingWeek) {
            view = ViewEnum.TimelineWorkDaysWeek
          }

          const payload: PlanPayload = {
            profitCenterId: this.companyFilterValue.profitCenter!.id,
            departmentId: this.companyFilterValue.department!.id,
            calendarDate: this.currentPeriod.formattedStartDate('DD/MM/YYYY'),
            view: view
          }

          const data: PlanResponse = await this.$store.dispatch(LOAD_PLAN, payload)

          const events: PlanResponse = []
          if(data) {
            data.forEach((item: PlanItem) => {
              if (this.companyFilterValue.department && item.Abteilung != this.companyFilterValue.department.id && item.type === 'shift') {
                item.type = 'floater'
                item.style = 'background-color: lightgray; color: white!important;'
              } else if (item.type === 'originalShift') {
                item.style = 'background-color: lightgray; color: white!important;'
              } else if(item.STV === 1) {
                item.style = `background-image: repeating-linear-gradient(135deg, lightgray, lightgray 5px, #fff 5px, #fff 10px); color: white !important`
              } else if (item.type !== 'absence') {
                item.style = 'background-color: lightgray; color: white!important;'
              }
              events.push(item)
            })
          } else {
            this.loading = false
          }

          return EmployeeEvent.createListFromResponse(events, view, null, false)
        },

        async fetchShiftList (): Promise<Array<PlannedShift>> {
          let view: ViewEnum = ViewEnum.TimelineMonth
          if (this.period === DatePeriodEnum.Week) {
            view = ViewEnum.TimelineWeek
          } else if (this.period === DatePeriodEnum.Day) {
            view = ViewEnum.Day
          } else if (this.period === DatePeriodEnum.Year) {
            view = ViewEnum.TimelineYear
          } else if (this.period === DatePeriodEnum.WorkingWeek) {
            view = ViewEnum.TimelineWorkDaysWeek
          }

          const payload: ShiftListPayload = {
            profitCenterId: this.companyFilterValue.profitCenter!.id,
            departmentId: this.companyFilterValue.department!.id,
            calendarDate: this.currentPeriod.formattedStartDate('DD/MM/YYYY'),
            view: view
          }

          try {
            const data: ShiftPlanResponse | false = await this.$store.dispatch(LOAD_SHIFTS, payload)
            if (data) {
              return PlannedShift.createListFromResponse(data)
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
              return []
            }
          } catch {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
            return []
          }
        },

        async fetchAbsenceList (): Promise<Array<Absence>> {
          const payload: any = {
            profitCenterId: this.companyFilterValue.profitCenter!.id,
            departmentId: this.companyFilterValue.department!.id,
            startDate: this.currentPeriod.startDate,
            endDate: this.currentPeriod.endDate
          }

          const data: Array<Absence> = await this.$store.dispatch(LOAD_ABSENCES, payload)
          return data
        },
        // </editor-fold>

        async updateDataSet (): Promise<void> {
          const profitCenter = this.companyFilterValue.profitCenter
          const department = this.companyFilterValue.department

          if (profitCenter && department) {
            this.loading = true

            const promise1: Promise<EmployeeEvent[]> = this.fetchEventList()
            const promise2: Promise<Absence[]> = this.fetchAbsenceList()

            const values = await Promise.all([promise1, promise2])

            const eventList: Array<EmployeeEvent> = values[0]
            this.absenceList = values[1]

            EmployeeEvent.createListFromAbsenceList(this.absenceList, eventList[0] ? _.maxBy(eventList, 'id')!.id : 0, this.allowAbsenceDragAndDrop).forEach((item: EmployeeEvent) => {
              const foundEvent: EmployeeEvent | undefined = eventList.find((i: EmployeeEvent) => i.absenceId === item.absenceId)
              if(foundEvent && eventList.indexOf(foundEvent) >= 0) {
                eventList.splice(eventList.indexOf(foundEvent), 1)
              }
              eventList.push(item)
            })

            this.employeeEventList = eventList

            employeeEventListIndexedByAbsenceId = {}
            for(let i in this.employeeEventList) {
              const ee: EmployeeEvent = this.employeeEventList[i]
              if(ee.absenceId) {
                if (employeeEventListIndexedByAbsenceId[ee.absenceId]) {
                  employeeEventListIndexedByAbsenceId[ee.absenceId].push(ee)
                } else {
                  employeeEventListIndexedByAbsenceId[ee.absenceId] = [ee]
                }
              }
            }

            this.employeeResourceList = this.createEmployeeResources()

            this.loading = false

            this.createFloaterEmployeeResources()
          } else {
            this.currentAbsence = undefined
          }
          //this.loading = false
        },

        updateSchedulerData (): void {
          // @ts-ignore
          const engine = this.$refs.scheduler.instance

          if (this.showOnlyEmployeesWithAbsence) {
            //const filteredEmployeeResourceList: Array<AbsencesEmployeeResource> = this.employeeResourceList.filter((item: AbsencesEmployeeResource) => item.eventList.length !== 0)

            engine.resourceStore.filterBy((item: any) => {
              return item.eventList.length !== 0 && item.eventList.filter((i: EmployeeEvent) => i.type === 'absence').length > 0
            })

            //this.schedulerResources = this.schedulerResources = _.filter(filteredEmployeeResourceList,
                //function (item) {return item.eventList.filter((i: EmployeeEvent) => i.type === 'absence').length > 0})

          } else {
            engine.resourceStore.clearFilters()
            this.schedulerResources = this.employeeResourceList
          }

          this.loading = false

          if ((this.toolbarFilterSearchString || this.toolbarFilterScope) !== 0 && this.filteredAbsenceList) {
            //const filteredEmployeeResourceList: Array<AbsencesEmployeeResource> = this.employeeResourceList.filter((item: AbsencesEmployeeResource) => this.hasSatisfySchedule(this.filteredAbsenceList!, item))
            engine.resourceStore.filterBy((item: any) => {
              return this.hasSatisfySchedule(this.filteredAbsenceList!, item) && item.eventList.filter((i: EmployeeEvent) => i.type === 'absence').length > 0
            })
            //this.schedulerResources = _.filter(filteredEmployeeResourceList,
                //function (item) {return item.eventList.filter((i: EmployeeEvent) => i.type === 'absence').length > 0})
          }

          if (this.companyFilterValue.department) {
            this.loadMessages()
          }
        },

        createEmployeeResources (): Array<AbsencesEmployeeResource> {
          const profitCenter = this.companyFilterValue.profitCenter
          const department = this.companyFilterValue.department

          if (profitCenter && department) {
            const employees = this.companyStructure.employeeList
                .filter((item: Employee) => item.profitCenter === profitCenter.id)
                .filter((item: Employee) => item.department === department.id)
                .filter((item: Employee) => item.planbar)

            this.filteredEmployees = []
            employees.forEach((item: Employee) => {
              this.filteredEmployees.push(item)
            })

            return AbsencesEmployeeResource.createListFromConfiguration(employees, this.companyStructure.planningGroupList, this.employeeEventList)
          }

          return []
        },

        createFloaterEmployeeResources (): void {
          const profitCenter = this.companyFilterValue.profitCenter
          const department = this.companyFilterValue.department
          let floaterList: Array<AbsencesEmployeeResource> = []

          if (profitCenter && department) {
            let employees: Array<Employee> = []

            this.companyStructure.employeeList.forEach((item: Employee) => {
              if (item.floaterDepartments.includes(department.id)) {
                if (item.planbar && item.floater) {
                  employees.push(item)
                }
              }
            })

            employees.forEach((item: Employee) => {
              this.filteredEmployees.push(item)
            })

            floaterList = AbsencesEmployeeResource.createFloaterList(employees, this.companyStructure.planningGroupList, this.employeeEventList)
          }

          floaterList.forEach((item: AbsencesEmployeeResource) => {
            this.employeeResourceList.push(item)
          })
        },

        openShiftEditor (): void {
          this.showAbsencesEditor = true
        },

        closeAbsenceEditor (): void {
          this.showAbsencesEditor = false
          this.absencesEditorPayload = undefined
        },

        async loadMessages (): Promise<any> {
          const messagesList = await this.$store.dispatch(MESSAGING_LOAD_NEW_MESSAGES)
          this.$store.commit(MESSAGING_SET_MESSAGES_DATA_MUTATION, messagesList)
        },

        onSchedulerEventClick (e: any): void {
          this.selectedDetailId = e.eventRecord.data.absenceId
          /*this.unselect = true
          this.selectedAbsence = undefined
          // @ts-ignore
          const engine = this.$refs.scheduler.instance
          engine.clearEventSelection()

          this.selectedDetailId = e.eventRecord.data.absenceId*/
        },

        onSchedulerEventDblClick (e: any): void {
          this.selectedDetailId = e.eventRecord.data.absenceId
          this.selectedAbsenceTemplateName = e.eventRecord.data.name

          if(this.selectedAbsenceTemplateName) {

            this.onActivateFastPlanning(true)
          } else {
            this.selectedAbsenceTemplateName = undefined
          }
        },

        onApprovedAbsencesClick (): void {
          this.approvedAbsences()
        },

        async approvedAbsences (): Promise<void> {
          if (this.checkedList.length > 0) {
            let payload: number[] = []

            if(this.isSelectAbsenceSerieActive) {
              this.checkedList.forEach((item: CheckedAbsenceList) => {
                if(item.serieId) {
                  const filteredAbsences: Absence[] = this.absenceList.filter((i: Absence) => i.serieId === item.serieId)
                  filteredAbsences.forEach((a: Absence) => {
                    if(!payload.includes(a.MRAID)) {
                      payload.push(a.MRAID)
                    }
                  })
                } else {
                  payload.push(item.MRAID)
                }
              })
            } else {
              this.checkedList.forEach((item: CheckedAbsenceList) => {
                payload.push(item.MRAID)
              })
            }

            try {
              this.loading = true
              await this.$store.dispatch(APPROVED_ABSENCES_CHECKED_LIST, payload)
              this.loading = false
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
              this.showSnackbar = true
              this.updateDataSet().then(() => this.updateSchedulerData())
            } catch (e) {
              this.loading = false
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
            }

          } else if (this.selectedAbsence) {
            let payload: number[] = []

            if(this.isSelectAbsenceSerieActive) {
              const foundAbsence: Absence | undefined = this.absenceList.find((item: Absence) => item.id === this.selectedAbsence.absenceId)
              if (foundAbsence && foundAbsence.serieId) {
                const filteredAbsences: Absence[] = this.absenceList.filter((i: Absence) => i.serieId === foundAbsence.serieId)
                filteredAbsences.forEach((a: Absence) => {
                  payload.push(a.MRAID)
                })
              } else if(foundAbsence) {
                payload.push(foundAbsence.MRAID)
              }
            } else {
              const foundAbsence: Absence | undefined = this.absenceList.find((item: Absence) => item.id === this.selectedAbsence.absenceId)
              if (foundAbsence) {
                payload.push(foundAbsence.MRAID)
              }
            }

            try {
              this.loading = true
              await this.$store.dispatch(APPROVED_ABSENCES_CHECKED_LIST, payload)
              this.loading = false
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
              this.showSnackbar = true
              this.updateDataSet().then(() => this.updateSchedulerData())
            } catch (e) {
              this.loading = false
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
            }
          }
        },

        onCloseDrawerClick (): void {
          this.drawer = false
        },

        setTimeRanges (startDate: Date, endDate: Date): void {
          let start = moment(startDate)
          let end = moment(endDate)
          let day = 0

          let result = this.holidayList
          let current = start.clone()

          while (current.day(7 + day).isBefore(end)) {
            const sun = current.clone().format('YYYY-MM-DD')
            const sat = moment(current.clone()).subtract(1, 'd').format('YYYY-MM-DD')

            const foundSun: TimeRange | undefined = _.find(this.holidayList, { startDate: sun })
            const foundSat: TimeRange | undefined = _.find(this.holidayList, { startDate: sat })

            if(!foundSun) {
              result.push({ startDate: sun, duration: 1, durationUnit: 'day' })
            }
            if(!foundSat) {
              result.push({ startDate: sat, duration: 1, durationUnit: 'day' })
            }
          }

          this.timeRanges = result
        },

        async getToolTip (data: any, tip: any): Promise<string> {
          tip.tooltipCopyData = new Map();
          let showAddressTooltip = securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxAdress)
          let tooltipDepartment: string = ''

          const startText: string = moment(data.eventRecord.data.startDateOriginal).format('HH:mm')
          const endText: string = moment(data.eventRecord.data.endDateOriginal).format('HH:mm')
          const startDate: string = moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY HH:mm')
          const endDate: string = moment(data.eventRecord.data.endDateOriginal).format('DD.MM.YYYY HH:mm')

          if(showAddressTooltip && (data.eventRecord.type === 'shift' || data.eventRecord.type === 'floater' || data.eventRecord.type === 'originalShift')) {
            const response: NoteTooltip = await this.$store.dispatch(FETCH_SHIFT_TOOLTIP, data.eventRecord.data.projectShiftDetailId)
            tip.tooltipEmployeeMobile = response.employeeMobile
            let address: string = response.address ? response.address.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''
            let preferencesData: string = response.preferences ? response.preferences.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''
            let pauseData: string | null = response.pauseText ? response.pauseText.replace(/(?:\r\n|\r|\n)/g, '<br>') : null

            let tooltipDepartment: string = ''
            let preferences: string = ''
            if(!this.isCapelo) {
              tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${response.departmentName}</td>
              </tr>`
            } else {
              preferences = `<tr>
                <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.preferences')} :</td>
                <td>${preferencesData}</td>
              </tr>`
            }

            let pause: string = ''
            if(pauseData) {
              pause = `<tr>
                <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.pause')} :</td>
                <td>${pauseData}</td>
              </tr>`
            }

            if(data.eventRecord.data.isReplacement) {
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employee'), data.eventRecord.type === 'originalShift' ? data.eventRecord.resource.fullName : response.employeeName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.replacement'), data.eventRecord.type === 'originalShift' ? response.responsibleName : data.eventRecord.resource.fullName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employeeMobile'), response.employeeMobile);
              if(!this.isCapelo) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.department'), response.departmentName);
              }
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.date'), `${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}`);
              tip.tooltipCopyData.set(`${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')}`, `${startText} - ${endText}`);
              if(pauseData) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.pause'), response.pauseText ? response.pauseText.replace(/<br \/>/gi, '\n') : '');
              }
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.address'), `${data.eventRecord.data.addressNumber} ${response.address}`);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.email'), response.email);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.mobile'), response.mobile);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.note'), response.note);
              if(this.isCapelo) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.preferences'), response.preferences ? response.preferences.replace(/<br \/>/gi, '\n') : '');
              }

              return `
              <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td> ${data.eventRecord.type === 'originalShift' ? data.eventRecord.resource.fullName : response.employeeName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.replacement')} :</td>
                    <td>${data.eventRecord.type === 'originalShift' ? response.responsibleName : data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.employeeMobile}")> ${response.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  ${pause}
                  <tr>
                    <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.address')}:</td>
                    <td>${data.eventRecord.data.addressNumber} <br> ${address}</td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.email')}:</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="mailto:${response.email}")> ${response.email} </a>
                    </td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.mobile')}:</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.mobile}")> ${response.mobile} </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${response.note}</td>
                  </tr>
                  ${preferences}
                </table>
              </dl>
              `
            } else {
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employee'), data.eventRecord.resource.fullName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employeeMobile'), response.employeeMobile);
              if(!this.isCapelo) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.department'), response.departmentName);
              }
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.date'), `${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}`);
              tip.tooltipCopyData.set(`${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')}`, `${startText} - ${endText}`);
              if(pauseData) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.pause'), response.pauseText ? response.pauseText.replace(/<br \/>/gi, '\n') : '');
              }
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.address'), `${data.eventRecord.data.addressNumber} ${response.address}`);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.email'), response.email);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.mobile'), response.mobile);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.note'), response.note);
              if(this.isCapelo) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.preferences'), response.preferences ? response.preferences.replace(/<br \/>/gi, '\n') : '');
              }

              return `
              <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.employeeMobile}")> ${response.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  ${pause}
                  <tr>
                    <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.address')}:</td>
                    <td>${data.eventRecord.data.addressNumber} <br> ${address}</td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.email')}:</td>
                     <td>
                      <a style="color: black; text-decoration: none" href="mailto:${response.email}")> ${response.email} </a>
                    </td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.mobile')}:</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.mobile}")> ${response.mobile} </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${response.note}</td>
                  </tr>
                  ${preferences}
                </table>
              </dl>
              `
            }
          } else {

            let additionalTooltip = {
              departmentName: '',
              employeeMobile: '',
              medicalCertificateUntil: '',
              absenceNote: ''
            }
            if(data.eventRecord.data.type === 'absence') {
              const responseTooltip: any = await this.$store.dispatch(FETCH_ABSENCE_TOOLTIP, data.eventRecord.data.absenceId)
              if(responseTooltip && responseTooltip.Tooltip) {
                additionalTooltip.departmentName = responseTooltip.Tooltip.AbteilungBezeichnung ? responseTooltip.Tooltip.AbteilungBezeichnung : ''
                additionalTooltip.employeeMobile = responseTooltip.Tooltip.MAMobil ? responseTooltip.Tooltip.MAMobil : ''
                additionalTooltip.medicalCertificateUntil = responseTooltip.Tooltip.Arztzeugnis_GueltigBis ? `<tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.medicalCertificateUntil')}:</td>
                    <td>${moment(responseTooltip.Tooltip.Arztzeugnis_GueltigBis).format('DD.MM.YYYY')}</td>
                  </tr>` : ''

                additionalTooltip.absenceNote = responseTooltip.Tooltip.Bemerkung && responseTooltip.Tooltip.Bemerkung.length > 0 ? `<tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${responseTooltip.Tooltip.Bemerkung}</td>
                  </tr>` : ''
              }

              if(!this.isCapelo) {
                tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${additionalTooltip.departmentName}</td>
              </tr>`
              }

              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employee'), data.eventRecord.resource.fullName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employeeMobile'), additionalTooltip.employeeMobile);
              if(!this.isCapelo) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.department'), additionalTooltip.departmentName);
              }
              tip.tooltipCopyData.set(this.$i18n.t('absencesPage.absence'), data.eventRecord.data.name);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.start'), startDate);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.end'), endDate);
              if(responseTooltip.Tooltip.Arztzeugnis_GueltigBis) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.medicalCertificateUntil'), moment(responseTooltip.Tooltip.Arztzeugnis_GueltigBis).format('DD.MM.YYYY'));
              }
              if(responseTooltip.Tooltip.Bemerkung && responseTooltip.Tooltip.Bemerkung.length > 0) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.note'), responseTooltip.Tooltip.Bemerkung);
              }

              return `
          <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${additionalTooltip.employeeMobile}")> ${additionalTooltip.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('absencesPage.absence')} :</td>
                    <td>${data.eventRecord.data.name}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} :</td>
                    <td>${startDate}</td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.end')} :</td>
                    <td>${endDate}</td>
                  </tr>
                  ${additionalTooltip.medicalCertificateUntil}
                  ${additionalTooltip.absenceNote}
                </table>
              </dl>`
            } else if (data.eventRecord.data.type === 'calendar') {
              const responseTooltip: any = await this.$store.dispatch(FETCH_CALENDAR_ART_TOOLTIP, data.eventRecord.data.kaId)
              if(responseTooltip && responseTooltip.Tooltip) {
                additionalTooltip.departmentName = responseTooltip.Tooltip.AbteilungBezeichnung ? responseTooltip.Tooltip.AbteilungBezeichnung : ''
                additionalTooltip.employeeMobile = responseTooltip.Tooltip.MAMobil ? responseTooltip.Tooltip.MAMobil : ''
              }

              if(!this.isCapelo) {
                tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${additionalTooltip.departmentName}</td>
              </tr>`
              }

              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employee'), data.eventRecord.resource.fullName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employeeMobile'), additionalTooltip.employeeMobile);
              if(!this.isCapelo) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.department'), additionalTooltip.departmentName);
              }
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.calendarEvent'), data.eventRecord.data.name);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.date'), `${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / KW ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}`);
              tip.tooltipCopyData.set(`${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')}`, `${startText} - ${endText}`);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.note'), responseTooltip.Tooltip.Beschreibung ? responseTooltip.Tooltip.Beschreibung : '');

              return `
          <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${additionalTooltip.employeeMobile}")> ${additionalTooltip.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.calendarEvent')} :</td>
                    <td>${data.eventRecord.data.name}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / KW ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${responseTooltip.Tooltip.Beschreibung ? responseTooltip.Tooltip.Beschreibung : ''}</td>
                  </tr>
                </table>
              </dl>`
            } else if (data.eventRecord.data.type === 'shift'|| data.eventRecord.type === 'originalShift' || data.eventRecord.type === 'floater') {
              const response: NoteTooltip = await this.$store.dispatch(FETCH_SHIFT_TOOLTIP, data.eventRecord.data.projectShiftDetailId)
              tip.tooltipEmployeeMobile = response.employeeMobile
              let pauseData: string | null = response.pauseText ? response.pauseText.replace(/(?:\r\n|\r|\n)/g, '<br>') : null

              let pause: string = ''
              if(pauseData) {
                pause = `<tr>
                <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.pause')} :</td>
                <td>${pauseData}</td>
              </tr>`
              }

              let tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${response.departmentName}</td>
              </tr>`

              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employee'), data.eventRecord.resource.fullName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.employeeMobile'), response.employeeMobile);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.department'), response.departmentName);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.tooltipShiftLabel'), data.eventRecord.data.name);
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.date'), `${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}`);
              tip.tooltipCopyData.set(`${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')}`, `${startText} - ${endText}`);
              if(pauseData) {
                tip.tooltipCopyData.set(this.$i18n.t('planningPage.pause'), response.pauseText ? response.pauseText.replace(/<br \/>/gi, '\n') : '');
              }
              tip.tooltipCopyData.set(this.$i18n.t('planningPage.note'), response.note);

              return `
              <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.employeeMobile}")> ${response.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.tooltipShiftLabel')} :</td>
                    <td>${data.eventRecord.data.name}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  ${pause}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${response.note}</td>
                  </tr>
                </table>
              </dl>
              `
            }

            return ''
          }
        },

        setDataFromRoute () {
          let data: any = undefined
          try {
            //@ts-ignore
            data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : undefined
          } catch (e) {
            data = undefined
          }

          let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
          if(data && data.currentPeriod && data.currentPeriod.startDate && moment(data.currentPeriod.startDate).isValid() && data.currentPeriod.period) {
            this.currentPeriod = DatePeriod.createFromDateString(moment(data.currentPeriod.startDate).format('YYYY-MM-DD'), data.currentPeriod.period)
          } else if(schedulingData && schedulingData.data && schedulingData.data.currentPeriod && schedulingData.data.currentPeriod.startDate && moment(schedulingData.data.currentPeriod.startDate).isValid() && schedulingData.data.currentPeriod.period) {
            this.currentPeriod = DatePeriod.createFromDateString(moment(schedulingData.data.currentPeriod.startDate).format('YYYY-MM-DD'), schedulingData.data.currentPeriod.period)
          } else {
            this.currentPeriod = DatePeriod.createFromNow(DatePeriodEnum.Month)
          }

          this.schedulerStartDate = this.currentPeriod.startDate
          this.schedulerEndDate = this.currentPeriod.endDate
        }

      },

      created () {
        this.setDataFromRoute()

        this.allowAbsenceDragAndDrop = !securityService.isDisabled(SecurityArea.Absences, SecurityComponent.DragDrop)

        document.documentElement.style.setProperty('--textOverflow', 'hidden')

        this.eventContextMenuFeature = {
          items: {
            editEvent: false,
            copyEvent: false,
            cutEvent: false,
            deleteEvent: false,
            unassignEvent: false,
            extraItem1 : {
              text : this.$i18n.t('planningPage.eventMenuTooltip'),
              icon : 'b-fa b-fa-fw b-fa-info-circle',
              onItem: ({eventRecord}: any) => {
                let elem: HTMLElement | null = document.querySelector(`[data-event-id="${eventRecord.data.id}"]`)

                const tooltip = new Tooltip({
                  align: 't-b',
                  autoClose: false,
                  closable: true,
                  preventTooltipOnTouch: true,
                  allowOver: true,
                  hideDelay : 99999999,
                  autoShow: true,
                  positioned: true,
                  draggable: true,
                  forElement: elem ? elem : undefined,
                  header: {
                    cls: eventRecord.data.type === 'shift' ? 'white-underlay' : '',
                    title: eventRecord.data.colorCode},
                  tbar: {
                    cls: 'tooltip-tbar',
                    items: [
                      {
                        text : '',
                        icon : 'b-fa b-fa-copy',
                        cls: 'tooltip-copy tooltip-icon',
                        onClick: () => {
                          let text: string = ''
                          //@ts-ignore
                          tooltip.tooltipCopyData.forEach((value: string, key: string) => {
                            text += `${key}: ${value} \n`
                          })
                          navigator.clipboard.writeText(text.trimEnd())
                          this.messageSnackbar = this.$t('planningPage.tooltipCopy')
                          this.snackbarState = SnackbarStateEnum.Success
                          this.showSnackbar = true
                        } },
                      {
                        text : '',
                        icon : 'b-fa b-fa-whatsapp',
                        cls: eventRecord.data.type === 'shift' || eventRecord.data.type === 'floater' || eventRecord.data.type === 'originalShift' ? 'tooltip-whatsapp mdi mdi-whatsapp' : 'tooltip-whatsapp tooltip-icon-hide',
                        onClick: () => {
                          //@ts-ignore
                          if(tooltip.tooltipEmployeeMobile && tooltip.tooltipEmployeeMobile.length > 0) {
                            let text: string = ''
                            //@ts-ignore
                            tooltip.tooltipCopyData.forEach((value: string, key: string) => {
                              text += `${key}: ${value} \n`
                            })
                            //@ts-ignore
                            window.open(`https://wa.me/${tooltip.tooltipEmployeeMobile.replace(/\s+/g, '')}?text=${encodeURIComponent(text.trimEnd())}`, '_blank');
                          } else {
                            this.messageSnackbar = this.$t('planningPage.whatsAppError')
                            this.snackbarState = SnackbarStateEnum.Error
                            this.showSnackbar = true
                          }
                        } }
                    ]
                  },
                  bbar: {
                    cls: 'tooltip-bbar',
                    items: [
                      { cls: 'tooltip-empty' },
                      {
                        text : this.$i18n.t('planningPage.tooltipCloseAll'),
                        cls: 'tooltip-closeall',
                        onClick: () => {
                          this.tooltipList.forEach((item: any) => {
                            item.close()
                          })
                        }
                      },
                    ]
                  },
                  listeners : {
                    // @ts-ignore
                    beforeShow : ({ source : tip }) => {
                      tip.html = this.getToolTip({eventRecord}, tip)
                    },
                    hide: () => {
                      tooltip.disable()
                    },
                  }
                })

                // @ts-ignore
                const header: any = document.querySelector(`header[data-owner-cmp="${tooltip.currentElement.id}"]`)
                if(eventRecord.style.includes("background-image") && eventRecord.type !== 'originalShift') {
                  header.style = `background-image: repeating-linear-gradient(135deg, ${eventRecord.eventColor}, ${eventRecord.eventColor} 5px, #fff 5px, #fff 10px); color: black !important`
                } else {
                  header.style.backgroundColor = eventRecord.eventColor
                }

                const headerTitle: any = header.children
                headerTitle[0].style.color = getColorContrast(eventRecord.eventColor)
                headerTitle[1].style.color = getColorContrast(eventRecord.eventColor)

                this.tooltipList.push(tooltip)

                tooltip.disable()
              }
            },
            extraItem2: !securityService.isDisabled(SecurityArea.Absences, SecurityComponent.IconDelete) ? {
              text: this.$i18n.t('planningPage.eventMenuDelete'),
              icon : 'b-fa b-fa-fw b-fa-trash',
              onItem: ({eventRecord}: any) => {
                if(eventRecord.data.type === 'absence') {
                  this.selectedAbsence = eventRecord.data
                  this.onDeleteAbsenceClick()
                }
              }
            } : undefined
          }
        }

        this.eventTooltipFeature = {
          disabled: true,
          /*template : async (data: any) => {
            const startText: string = moment(data.eventRecord.data.startDateOriginal).format('HH:mm')
            const endText: string = moment(data.eventRecord.data.endDateOriginal).format('HH:mm')

            let tooltipDepartment: string = ''

            if(data.eventRecord.type === 'shift' || data.eventRecord.type === 'floater') {
              if(!this.isCapelo) {
                const response: NoteTooltip = await this.$store.dispatch(FETCH_SHIFT_TOOLTIP, data.eventRecord.data.projectShiftDetailId)
                tooltipDepartment = `<dt>${response.departmentName}</dt>`
              }
              return `<dl>
                      <dt>${data.eventRecord.resource.fullName}</dt>
                      ${tooltipDepartment}
                      <dt>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</dt>
                      <dt>${data.eventRecord.data.name}</dt>
                      <dt>${this.$i18n.t('planningPage.start')} : ${startText}</dt>
                      <dt>${this.$i18n.t('planningPage.end')} : ${endText}</dt>
                  </dl>
                  `
            } else {
              return `<dl>
                      <dt>${data.eventRecord.resource.fullName}</dt>
                      <dt>${moment(data.eventRecord.data.startDate).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDate).isoWeek()}</dt>
                      <dt>${data.eventRecord.data.name}</dt>
                      <dt>${this.$i18n.t('planningPage.start')} : ${startText}</dt>
                      <dt>${this.$i18n.t('planningPage.end')} : ${endText}</dt>
                  </dl>
                  `
            }
          }*/
        }
      },

      async mounted () {
        await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
        this.companyStructure = this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]

        const holidays: Array<Holiday> = this.$store.getters[COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST]
        holidays.forEach((item: Holiday) => {
          const date: string = moment(item.date, 'DD.MM.YYYY').format('YYYY-MM-DD')
          this.holidayList.push({ startDate : date, duration : 1, durationUnit : 'day', data: item.data })
        })
        this.setTimeRanges(this.currentPeriod.startDate, this.currentPeriod.endDate)

        // @ts-ignore
        const engine = this.$refs.scheduler.instance

        engine.on({
          beforeEventDelete: (event: any) => {
            if((!securityService.isDisabled(SecurityArea.Absences, SecurityComponent.IconDelete)) && event.eventRecords[0].type === 'absence') {
              this.onDeleteAbsenceClick()
            }
            return false
          }
        })

      }
    }
)
